/* Raine & Co help pages: topic list, form checks, help and FAQ search, ring and bracelet finders, the instalment
   calculator and product rails. Content is server rendered; this only adds behaviour. Uses window.RC from theme.js. */
(function () {
  'use strict';
  var D = document, W = window;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var NB = ' ';
  function RC() { return W.RC || {}; }
  function reveal() { if (RC().initReveal) RC().initReveal(); }

  /* ---------- topic list: keep the current topic in view on phones ---------- */
  var hnav = $('#hnav');
  if (hnav) {
    var cur = $('[aria-current="page"]', hnav);
    if (cur && W.matchMedia('(max-width:900px)').matches) { var ul = $('ul', hnav); ul.scrollLeft = cur.parentNode.offsetLeft - 16; }
  }

  /* ---------- forms: check required fields before Shopify sends the message ---------- */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function check(form) {
    var ok = true, first = null;
    $$('[required]', form).forEach(function (i) {
      var v = String(i.value || '').trim();
      var bad = i.type === 'checkbox' ? !i.checked : (!v || (i.type === 'email' && !validEmail(v)));
      i.setAttribute('aria-invalid', bad ? 'true' : 'false');
      var er = i.id ? D.getElementById(i.id + '-e') : null;
      if (er) er.textContent = bad ? (i.type === 'email' && v ? 'Enter an email address like name@example.com.' : 'This field is needed.') : '';
      if (bad && !first) first = i;
      if (bad) ok = false;
    });
    if (first) first.focus();
    return ok;
  }
  $$('form.hform').forEach(function (form) {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) { if (!check(form)) e.preventDefault(); });
    $$('input, select, textarea', form).forEach(function (el) {
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true' && String(el.value).trim()) { el.setAttribute('aria-invalid', 'false'); var er = D.getElementById(el.id + '-e'); if (er) er.textContent = ''; } });
    });
  });
  var done = $('.fok.show');
  if (done) { done.focus(); done.scrollIntoView({ block: 'center' }); }

  /* contact topic from the link, such as /pages/contact#returns */
  var topic = $('#c-topic');
  if (topic && location.hash) {
    var h = location.hash.slice(1);
    $$('option', topic).forEach(function (o) { if (o.getAttribute('data-k') === h) topic.value = o.value; });
  }

  /* copy the email address */
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = b.getAttribute('data-copy'), label = b.textContent;
      var ok = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = label; }, 1800); };
      var sel = function () { var el = b.parentNode.parentNode.querySelector('.addr'); if (!el) return; var r = D.createRange(); r.selectNodeContents(el); var s = W.getSelection(); s.removeAllRanges(); s.addRange(r); b.textContent = 'Press Ctrl+C or Cmd+C to copy'; };
      try { navigator.clipboard.writeText(t).then(ok, sel); } catch (e) { sel(); }
    });
  });

  /* ---------- search answers ---------- */
  function words(q) { return q.toLowerCase().trim().split(/\s+/).filter(Boolean); }
  function matches(el, toks) { var h = el.textContent.toLowerCase(); return toks.every(function (t) { return h.indexOf(t) > -1; }); }

  // FAQ page: filter the questions in place
  var fq = $('#faq-q');
  if (fq) {
    var none = $('#faq-none');
    fq.addEventListener('input', function () {
      var toks = words(fq.value), any = false;
      $$('#faq-groups .fgrp').forEach(function (g) {
        var hit = 0;
        $$('details', g).forEach(function (d) { var m = !toks.length || matches(d, toks); d.hidden = !m; if (m) hit++; });
        g.hidden = !hit; if (hit) any = true;
      });
      if (none) none.hidden = any;
      var jump = $('#faq-jump'); if (jump) jump.hidden = !!toks.length;
    });
  }

  // Help centre: search the answers on the FAQ page
  var hs = $('#help-search'), sr = $('#sres'), bank = null;
  function loadBank() {
    if (bank) return Promise.resolve(bank);
    return fetch('/pages/faq', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      bank = $$('#faq-groups details', doc).map(function (d) { return d.outerHTML; });
      return bank;
    }).catch(function () { bank = []; return bank; });
  }
  if (hs && sr) {
    var render = function () {
      var toks = words(hs.value);
      if (hs.value.trim().length < 2) { sr.innerHTML = ''; return; }
      loadBank().then(function (list) {
        var tmp = D.createElement('div');
        var hits = list.filter(function (h) { tmp.innerHTML = h; return matches(tmp, toks); });
        sr.innerHTML = '<div class="wrap"><p class="kick-sm" style="padding-top:28px">' + (hits.length ? hits.length + (hits.length === 1 ? ' answer' : ' answers') + ' found' : 'No answers found') + '</p>' +
          (hits.length ? '<div class="faq">' + hits.slice(0, 8).join('') + '</div>' : '<p class="none">Try delivery, returns, ring size or Payflex, or <a class="link-line" href="/pages/contact">send us a message</a>.</p>') + '</div>';
        var first = $('#sres details'); if (first) first.open = true;
      });
    };
    hs.addEventListener('focus', loadBank, { once: true });
    hs.addEventListener('input', render);
    $('#help-search-f').addEventListener('submit', function (e) { e.preventDefault(); render(); setTimeout(function () { var f = $('#sres summary'); if (f) f.focus(); }, 300); });
  }

  /* ---------- ring size finder (US sizes, SA/UK letters for reference) ---------- */
  var CHART = [
    ['H', 'H', '3¾', 46.1], ['I', 'I', '4¼', 47.4], ['J', 'J', '4¾', 48.7], ['K', 'K', '5¼', 50.0], ['L', 'L', '5¾', 51.3], ['L½', 'Lh', '6', 51.9],
    ['M', 'M', '6¼', 52.6], ['N', 'N', '6¾', 53.9], ['N½', 'Nh', '7', 54.4], ['O', 'O', '7¼', 55.1], ['P', 'P', '7¾', 56.4], ['P½', 'Ph', '8', 57.0],
    ['Q', 'Q', '8¼', 57.6], ['R', 'R', '8¾', 58.9], ['S', 'S', '9¼', 60.2], ['T', 'T', '9¾', 61.5]
  ].map(function (r) { return { uk: r[0], key: r[1], us: r[2], c: r[3], d: Math.round(r[3] / Math.PI * 10) / 10 }; });
  var STOCK = { 'L½': { d: 16.5, c: 51.9 }, 'N½': { d: 17.3, c: 54.4 }, 'P½': { d: 18.2, c: 57.0 } };
  CHART.forEach(function (r) { if (STOCK[r.uk]) { r.d = STOCK[r.uk].d; r.c = STOCK[r.uk].c; } });
  var STOCKED = CHART.filter(function (r) { return STOCK[r.uk]; });
  var rf = $('#ring-f');
  if (rf) {
    var out = $('#ring-out');
    var ringCalc = function () {
      var v = parseFloat(String($('#r-mm').value).replace(',', '.')), m = $('#r-method').value;
      $$('#ring-table tr').forEach(function (r) { r.classList.remove('is-hl'); });
      if (!v) { out.innerHTML = 'Enter a measurement in millimetres to see your size.'; return; }
      var key = m === 'd' ? 'd' : 'c', lo = m === 'd' ? 14 : 44, hi = m === 'd' ? 21 : 66;
      if (v < lo || v > hi) { out.innerHTML = 'That measurement looks unusual for a ' + (m === 'd' ? 'diameter' : 'circumference') + '. Check you measured in millimetres, not centimetres.'; return; }
      var near = CHART.slice().sort(function (a, b) { return Math.abs(a[key] - v) - Math.abs(b[key] - v); })[0];
      var row = $('#ring-table tr[data-uk="' + near.key + '"]'); if (row) row.classList.add('is-hl');
      var tol = m === 'd' ? 0.15 : 0.5, slack = m === 'd' ? 0.6 : 2;
      var pick = STOCKED.filter(function (s) { return s[key] >= v - tol; })[0];
      var mine = 'Your size is about <b>US ' + near.us + '</b> (' + near.d.toFixed(1) + ' mm across, SA/UK ' + near.uk + '). ';
      if (v < STOCKED[0][key] - slack) { out.innerHTML = mine + 'That is smaller than US 6, our smallest size, so try one of our open rings, which fit most fingers.'; return; }
      if (!pick || v > STOCKED[STOCKED.length - 1][key] + slack) { out.innerHTML = mine + 'That is larger than US 8, our largest size, so try one of our open rings, which fit most fingers.'; return; }
      out.innerHTML = mine + (pick.uk === near.uk ? 'We stock this size, so choose <b class="b-sm">US ' + pick.us + '</b> on the product page.' : 'Choose <b class="b-sm">US ' + pick.us + '</b>, the closest size we stock that is not smaller than your finger.');
    };
    rf.addEventListener('submit', function (e) { e.preventDefault(); ringCalc(); });
    $('#r-mm').addEventListener('input', ringCalc);
    $('#r-method').addEventListener('change', ringCalc);
  }

  /* ---------- bracelet and anklet finder ---------- */
  var bf = $('#brace-f');
  if (bf) {
    var braceCalc = function () {
      var v = parseFloat(String($('#b-cm').value).replace(',', '.')), what = $('#b-what').value, o = $('#brace-out');
      if (!v) { o.innerHTML = 'Enter your measurement in centimetres.'; return; }
      var lo = what === 'wrist' ? 12 : 17, hi = what === 'wrist' ? 22 : 30;
      if (v < lo || v > hi) { o.innerHTML = 'That looks unusual for a' + (what === 'wrist' ? ' wrist' : 'n ankle') + '. Check you measured in centimetres.'; return; }
      var add = what === 'wrist' ? [1.5, 2] : [2, 3];
      var a = (v + add[0]).toFixed(1).replace('.0', ''), b = (v + add[1]).toFixed(1).replace('.0', '');
      o.innerHTML = '<b>' + a + ' to ' + b + ' cm</b> is the ' + (what === 'wrist' ? 'bracelet' : 'anklet') + ' length to look for. Pieces with an extender chain cover a range, so check the length on the product page.';
    };
    bf.addEventListener('submit', function (e) { e.preventDefault(); braceCalc(); });
    $('#b-cm').addEventListener('input', braceCalc);
    $('#b-what').addEventListener('change', braceCalc);
  }

  /* ---------- instalment calculator ---------- */
  var sel = $('#pay-piece');
  if (sel) {
    var money = function (n) { return 'R' + (Math.round(n * 100) / 100).toFixed(2).replace('.00', '').replace(/\B(?=(\d{3})+(?!\d))/g, NB); };
    var payCalc = function () {
      var t = Number(sel.value) || 0, q = t / 4, th = t / 3;
      $('#sched-pf').innerHTML = ['Today', 'In 2 weeks', 'In 4 weeks', 'In 6 weeks'].map(function (l) { return '<div><b>' + money(q) + '</b>' + l + '</div>'; }).join('');
      $('#sched-pjn').innerHTML = ['Today', 'In 1 month', 'In 2 months'].map(function (l) { return '<div><b>' + money(th) + '</b>' + l + '</div>'; }).join('');
    };
    sel.addEventListener('change', payCalc); payCalc();
  }

  reveal();
})();
